import {
  queryAgentBettingList,
  queryAgentBalanceDetailList,
  querySubuserRebate,
  querySubuserOneReport,
  queryTeamReport,
  addSubuser,
  updateSubuser,
  querySubuser,
  queryListTeamSubUsers
} from "@/api/agent";

import {
  ADD_AGENT_BETTINGINFO_LIST,
  ADD_AGENT_BALANCEDETAIL_LIST,
  ADD_AGENT_SUBUSERREBATE_LIST,
  ADD_AGENT_SUBUSER_ONE_REPORT,
  ADD_AGENT_TEAM_REPORT,
  ADD_AGENT_SUBUSER_LIST
} from "@/store/mutation_types";

const agent = {
  state: {
    bettingInfoList: {
      list: [],
      total: 0
    },
    balanceDetailList: {
      list: [],
      total: 0
    },
    subuserRebate: {
      buyMoneyTotal: 0,
      rebateList: [],
      rebateSumTotal: 0,
      total: 0
    },
    subuserOneReport: {
      buyTotal: 0,
      discountTotal: 0,
      fanliTotal: 0,
      prizeTotal: 0,
      profitLossTotal: 0,
      rebateTotal: 0,
      rechargeTotal: 0,
      takeFeeTotal: 0,
      tradeTime: null
    },
    teamReportList: [],
    subuserList: {
      list: [],
      total: 0,
      userDevRela: []
    }
  },
  mutations: {
    [ADD_AGENT_BETTINGINFO_LIST]: (state, playload) => {
      const { bettingInfoList, total } = playload;
      state.bettingInfoList.list = bettingInfoList;
      state.bettingInfoList.total = total;
    },
    [ADD_AGENT_BALANCEDETAIL_LIST]: (state, playload) => {
      const { balanceDetailList, total } = playload;
      state.balanceDetailList.list = balanceDetailList;
      state.balanceDetailList.total = total;
    },
    [ADD_AGENT_SUBUSERREBATE_LIST]: (state, playload) => {
      const {
        buyMoneyTotal = 0,
        rebateList = [],
        rebateSumTotal = 0,
        total = 0
      } = playload;
      state.subuserRebate.buyMoneyTotal = buyMoneyTotal;
      state.subuserRebate.rebateList = rebateList;
      state.subuserRebate.rebateSumTotal = rebateSumTotal;
      state.subuserRebate.total = total;
    },
    [ADD_AGENT_SUBUSER_ONE_REPORT]: (state, playload) => {
      const {
        buyTotal = 0,
        discountTotal = 0,
        fanliTotal = 0,
        prizeTotal = 0,
        profitLossTotal = 0,
        rebateTotal = 0,
        rechargeTotal = 0,
        takeFeeTotal = 0,
        tradeTime = null
      } = playload;
      state.subuserOneReport.buyTotal = buyTotal;
      state.subuserOneReport.discountTotal = discountTotal;
      state.subuserOneReport.fanliTotal = fanliTotal;
      state.subuserOneReport.prizeTotal = prizeTotal;
      state.subuserOneReport.profitLossTotal = profitLossTotal;
      state.subuserOneReport.rebateTotal = rebateTotal;
      state.subuserOneReport.rechargeTotal = rechargeTotal;
      state.subuserOneReport.takeFeeTotal = takeFeeTotal;
      state.subuserOneReport.tradeTime = tradeTime;
    },
    [ADD_AGENT_TEAM_REPORT]: (state, playload) => {
      state.teamReportList = playload;
    },
    [ADD_AGENT_SUBUSER_LIST]: (state, playload) => {
      const { list = [], total = 0, userDevRela = [] } = playload;
      state.subuserList.list = list;
      state.subuserList.total = total;
      state.subuserList.userDevRela = userDevRela;
    }
  },
  actions: {
    async queryAgentBettingList({ commit }, playload) {
      const blRes = await queryAgentBettingList(playload);
      const {
        data: { data = {} }
      } = blRes;
      commit(ADD_AGENT_BETTINGINFO_LIST, data);
      return blRes;
    },
    async queryAgentBalanceDetailList({ commit }, playload) {
      const bdlRes = await queryAgentBalanceDetailList(playload);
      const {
        data: { data = {} }
      } = bdlRes;
      commit(ADD_AGENT_BALANCEDETAIL_LIST, data);
      return bdlRes;
    },
    async queryAgentSubuserRebate({ commit }, playload) {
      const rRes = await querySubuserRebate(playload);
      const {
        data: { data = {} }
      } = rRes;
      commit(ADD_AGENT_SUBUSERREBATE_LIST, data);
      return rRes;
    },
    async queryAgentSubuserOneReport({ commit }, playload) {
      const { data, config } = playload;
      const onerRes = await querySubuserOneReport(data, config);
      const ret = onerRes.data.data;
      commit(ADD_AGENT_SUBUSER_ONE_REPORT, ret);
      return onerRes;
    },
    async queryAgentTeamReport({ commit }, playload) {
      const { data, config } = playload;
      const strRes = await queryTeamReport(data, config);
      const ret = strRes.data.data;
      commit(ADD_AGENT_TEAM_REPORT, ret);
      return strRes;
    },
    async addAgentSubuser(context, playload) {
      const { data, config } = playload;
      const asuRes = await addSubuser(data, config);
      return asuRes;
    },
    async updateAgentSubuser(context, playload) {
      const { data, config } = playload;
      const updateRes = await updateSubuser(data, config);
      return updateRes;
    },
    async queryAgentSubuser({ commit }, playload) {
      const subuserList = await querySubuser(playload);
      const {
        data: { data = {} }
      } = subuserList;
      commit(ADD_AGENT_SUBUSER_LIST, data);
      return subuserList;
    },
    async queryListTeamSubUsers({ commit }, playload) {
      return await queryListTeamSubUsers(playload);
    }
  }
};

export default agent;
